import capitalize from 'lodash/capitalize';

import searchTranslations from 'public/locales/en/search.json';
import commonTranslations from 'public/locales/en/common.json';

import { getTranslator } from '../shared/i18n/getTranslator';
import { currencyFormatter } from '../shared/helpers';

const tCommon = getTranslator(commonTranslations);
const t = getTranslator(searchTranslations);

const RADIUS_VALUES = [
    '0',
    '0.25',
    '0.5',
    '1',
    '3',
    '5',
    '10',
    '15',
    '20',
    '30',
    '40'
];

const MIN_MAX_BEDROOMS_VALUES = [
    '',
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10'
];

const PROPERTY_TYPE_VALUES = ['', 'houses', 'flats', 'farms_land'];

const MIN_MAX_PRICE_VALUES = [
    '0',
    '10000',
    '20000',
    '30000',
    '40000',
    '50000',
    '60000',
    '70000',
    '80000',
    '90000',
    '100000',
    '110000',
    '120000',
    '125000',
    '130000',
    '140000',
    '150000',
    '160000',
    '170000',
    '180000',
    '190000',
    '200000',
    '210000',
    '220000',
    '230000',
    '240000',
    '250000',
    '275000',
    '300000',
    '325000',
    '350000',
    '375000',
    '400000',
    '425000',
    '450000',
    '475000',
    '500000',
    '550000',
    '600000',
    '650000',
    '700000',
    '750000',
    '800000',
    '850000',
    '900000',
    '950000',
    '1000000',
    '1100000',
    '1200000',
    '1300000',
    '1400000',
    '1500000',
    '1600000',
    '1700000',
    '1800000',
    '1900000',
    '2000000',
    '2100000',
    '2200000',
    '2300000',
    '2400000',
    '2500000',
    '2750000',
    '3000000',
    '3250000',
    '3500000',
    '3750000',
    '4000000',
    '4250000',
    '4500000',
    '4750000',
    '5000000',
    '5500000',
    '6000000',
    '6500000',
    '7000000',
    '7500000',
    '8000000',
    '8500000',
    '9000000',
    '9500000',
    '10000000',
    '12500000',
    '15000000'
];

const MIN_MAX_PRICE_WEEKLY_VALUES = [
    '0',
    '25',
    '50',
    '75',
    '100',
    '125',
    '150',
    '175',
    '200',
    '225',
    '250',
    '275',
    '300',
    '325',
    '350',
    '375',
    '400',
    '425',
    '450',
    '475',
    '500',
    '550',
    '600',
    '650',
    '700',
    '750',
    '800',
    '850',
    '900',
    '950',
    '1000',
    '1250',
    '1500',
    '1750',
    '2000',
    '2500',
    '3000',
    '3500',
    '4000',
    '4500',
    '5000',
    '7500'
];

const MIN_MAX_PRICE_MONTHLY_VALUES = [
    '0',
    '100',
    '200',
    '300',
    '400',
    '500',
    '600',
    '700',
    '800',
    '900',
    '1000',
    '1250',
    '1500',
    '1750',
    '2000',
    '2250',
    '2500',
    '2750',
    '3000',
    '3250',
    '3500',
    '3750',
    '4000',
    '4250',
    '4500',
    '4750',
    '5000',
    '5500',
    '6000',
    '6500',
    '7000',
    '7500',
    '8000',
    '8500',
    '9000',
    '9500',
    '10000',
    '12500',
    '15000',
    '17500',
    '20000',
    '25000'
];

export enum PriceFrequency {
    PerMonth = 'per_month',
    PerWeek = 'per_week'
}
const PRICE_FREQUENCY_VALUES = [
    PriceFrequency.PerMonth,
    PriceFrequency.PerWeek
];

const PROPERTY_SUB_TYPE_VALUES = [
    'detached',
    'semi_detached',
    'terraced',
    'bungalow',
    'detached_bungalow',
    'semi_detached_bungalow',
    'terraced_bungalow',
    'cottage',
    'park_home'
];

const PROPERTY_ADDED_VALUES = [
    '',
    '24_hours',
    '3_days',
    '7_days',
    '14_days',
    '30_days'
];

const AVAILABLE_FROM_VALUES = [
    '',
    'now',
    '1months',
    '3months',
    '6months',
    '12months'
];

const FURNISHED_STATE_VALUES = [
    'Any',
    'furnished',
    'part_furnished',
    'unfurnished'
];

const MUST_HAVES_VALUES = [
    'has_garden',
    'has_parking_garage',
    'has_balcony_terrace',
    'has_porter_security',
    'has_wood_floors',
    'has_fireplace',
    'is_rural_secluded'
];

const DURATION_VALUES = ['900', '1800', '2700', '3600', '4500'];

const TRANSPORT_TYPE_VALUES = [
    'driving',
    'walking',
    'walking_train',
    'public_transport',
    'cycling'
];

export const filtersOptions = {
    radius: {
        options: RADIUS_VALUES.map((value) => {
            const tValue = value.replace('.', '-');

            return {
                label: t(`filters.field.radius.options.${tValue}`),
                value: value
            };
        }),
        selectedValue: RADIUS_VALUES[0]
    },
    minBedrooms: {
        options: MIN_MAX_BEDROOMS_VALUES.map((value) => {
            const tValue = value.replace('.', '-');
            const label = value
                ? t(`filters.field.beds_min.options.${tValue}`)
                : t(`filters.field.beds_min.options.default`);

            return {
                label,
                value: value
            };
        }),
        selectedValue: MIN_MAX_BEDROOMS_VALUES[0]
    },
    maxBedrooms: {
        options: MIN_MAX_BEDROOMS_VALUES.map((value) => {
            const tValue = value.replace('.', '-');
            const label = value
                ? t(`filters.field.beds_max.options.${tValue}`)
                : t(`filters.field.beds_max.options.default`);

            return {
                label,
                value: value
            };
        }),
        selectedValue: MIN_MAX_BEDROOMS_VALUES[0]
    },
    propertyType: {
        options: PROPERTY_TYPE_VALUES.map((value) => {
            return {
                label: t(`filters.field.property_type.options.${value}`),
                value: value
            };
        }),
        selectedValue: PROPERTY_TYPE_VALUES[0]
    },
    minPrice: {
        options: MIN_MAX_PRICE_VALUES.map((value) => {
            const label =
                value === '0'
                    ? t(`filters.field.price_min.options.default`)
                    : `${currencyFormatter.format(parseInt(value))}`;

            return {
                label,
                value
            };
        }),
        selectedValue: MIN_MAX_PRICE_VALUES[0]
    },
    maxPrice: {
        options: MIN_MAX_PRICE_VALUES.map((value) => {
            const label =
                value === '0'
                    ? t(`filters.field.price_max.options.default`)
                    : `${currencyFormatter.format(parseInt(value))}`;

            return {
                label,
                value
            };
        }),
        selectedValue: MIN_MAX_PRICE_VALUES[0]
    },
    minPriceWeekly: {
        options: MIN_MAX_PRICE_WEEKLY_VALUES.map((value) => {
            const label =
                value === '0'
                    ? t(`filters.field.price_min.options.default`)
                    : `${currencyFormatter.format(
                          parseInt(value, 10)
                      )} ${tCommon('frequency.per_week')}`;

            return {
                label,
                value
            };
        }),
        selectedValue: MIN_MAX_PRICE_WEEKLY_VALUES[0]
    },
    maxPriceWeekly: {
        options: MIN_MAX_PRICE_WEEKLY_VALUES.map((value) => {
            const label =
                value === '0'
                    ? t(`filters.field.price_max.options.default`)
                    : `${currencyFormatter.format(
                          parseInt(value, 10)
                      )} ${tCommon('frequency.per_week')}`;

            return {
                label,
                value
            };
        }),
        selectedValue: MIN_MAX_PRICE_WEEKLY_VALUES[0]
    },
    minPriceMonthly: {
        options: MIN_MAX_PRICE_MONTHLY_VALUES.map((value) => {
            const label =
                value === '0'
                    ? t(`filters.field.price_min.options.default`)
                    : `${currencyFormatter.format(
                          parseInt(value, 10)
                      )} ${tCommon('frequency.per_month')}`;

            return {
                label,
                value
            };
        }),
        selectedValue: MIN_MAX_PRICE_MONTHLY_VALUES[0]
    },
    maxPriceMonthly: {
        options: MIN_MAX_PRICE_MONTHLY_VALUES.map((value) => {
            const label =
                value === '0'
                    ? t(`filters.field.price_max.options.default`)
                    : `${currencyFormatter.format(
                          parseInt(value, 10)
                      )} ${tCommon('frequency.per_month')}`;

            return {
                label,
                value
            };
        }),
        selectedValue: MIN_MAX_PRICE_MONTHLY_VALUES[0]
    },
    priceFrequency: {
        options: PRICE_FREQUENCY_VALUES.map((value) => {
            const label = capitalize(value.replace('per_', ''));

            return {
                label,
                value
            };
        }),
        selectedValue: ''
    },
    propertySubTypes: {
        options: PROPERTY_SUB_TYPE_VALUES.map((value) => {
            return {
                label: t(`filters.field.property_sub_type.options.${value}`),
                value
            };
        }),
        selectedValue: []
    },
    propertyAdded: {
        options: PROPERTY_ADDED_VALUES.map((value) => {
            return {
                label: t(`filters.field.property_added.${value}`),
                value
            };
        }),
        selectedValue: PROPERTY_ADDED_VALUES[0]
    },
    availableFrom: {
        options: AVAILABLE_FROM_VALUES.map((value) => {
            return {
                label: t(`filters.field.available_from.options.${value}`),
                value
            };
        }),
        selectedValue: AVAILABLE_FROM_VALUES[0]
    },
    billsIncluded: {
        label: t(`filters.field.letting_options.options.bills_included`),
        selectedValue: false
    },
    underOfferOrSold: {
        label: t(`filters.field.include_sold.options.true`),
        selectedValue: false
    },
    chainFree: {
        label: t(`filters.field.chain_free.options.true`),
        selectedValue: false
    },
    priceReduced: {
        label: t(`filters.field.reduced_price_only.options.true`),
        selectedValue: false
    },
    includeSharedAccommodation: {
        label: t(`filters.field.shared_accommodation.include`),
        selectedValue: true
    },
    includeRented: {
        label: t(`filters.field.let_agreed.options.let_agreed`),
        selectedValue: false
    },
    furnishedState: {
        options: FURNISHED_STATE_VALUES.map((value) => {
            return {
                label: t(`filters.field.furnished_state.options.${value}`),
                value
            };
        }),
        selectedValue: FURNISHED_STATE_VALUES[0]
    },
    petsAllowed: {
        label: t(`filters.field.letting_options.options.pets_allowed`),
        selectedValue: false
    },
    rentalTerm: {
        label: t(`filters.field.letting_options.options.rental_term`),
        selectedValue: false
    },
    mustHaves: {
        options: MUST_HAVES_VALUES.map((value) => {
            return {
                label: t(`filters.field.feature.options.${value}`),
                value
            };
        }),
        selectedValue: []
    },
    isSharedOwnership: {
        label: t(`filters.field.is_shared_ownership.label`),
        selectedValue: true,
        disabled: false
    },
    auction: {
        label: 'Auction',
        selectedValue: true,
        disabled: false
    },
    retirementHome: {
        label: t(`filters.field.is_retirement_home.label`),
        selectedValue: false
    },
    newHomes: {
        label: t(`filters.field.new_homes.label`),
        selectedValue: false
    },
    preOwned: {
        label: t('filters.field.pre_owned.label'),
        selectedValue: false
    },
    incentives: {
        label: t(`filters.field.help_to_buy.label`),
        selectedValue: false
    },
    keywords: {
        label: t('filters.field.keywords.label'),
        tip: t('filters.field.keywords.tip'),
        placeholder: t('filters.field.keywords.placeholder'),
        selectedValue: ''
    },
    duration: {
        options: DURATION_VALUES.map((value) => {
            return {
                label: t(`filters.field.duration.options.${value}`),
                value
            };
        }),
        selectedValue: ''
    },
    transportType: {
        options: TRANSPORT_TYPE_VALUES.map((value) => {
            return {
                label: t(`filters.field.transportType.options.${value}`),
                value
            };
        }),
        selectedValue: ''
    },
    q: {
        selectedValue: ''
    },
    identifier: {
        selectedValue: ''
    },
    locationText: {
        selectedValue: ''
    }
};
